<template>
  <div class="edit-advertisement">
    <mdb-card v-if="this.loadReady === true">
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"
          ><strong>{{ $t("advertisement") }}</strong></mdb-card-title
        >
      </mdb-card-header>
      <mdb-card-body>
        <RetailerChainSelection
          v-on:member="member"
          :content="localAdvertisement"
        />
        <mdb-row>
          <mdb-col md="12">
            <GoogleMap
              v-on:marker-moved="markerMoved"
              :marker="computedMarker"
              class="google-map"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-5">
          <mdb-col md="12">
            <p class="h5">
              {{
                $t("advertisement_content") +
                ": " +
                getAdvertisementIdForUI().toString()
              }}
            </p>
          </mdb-col>
          <mdb-col md="12">
            <p class="h6">{{ $t("advertisement_focusing_union") }}</p>
          </mdb-col>
          <mdb-col md="6">
            <UnionMemberSelection
              :defaultSelection="String(localAdvertisement.unionmemberid)"
              v-on:unionmemberid="setUnionMemberId"
            />
          </mdb-col>
        </mdb-row>
        <hr class="banner" />
        <mdb-row>
          <mdb-col md="12">
            <p class="h4">{{ $t("advertisement_focusing_other") }}</p>
          </mdb-col>
          <mdb-col md="6">
            <mdb-input
              v-model="carouselactive"
              type="checkbox"
              id="checkBoxFocusing"
              :label="$t('advertisement_paid_focusing')"
            />
          </mdb-col>
          <mdb-col md="6">
            <mdb-input
              v-model="cardview"
              type="checkbox"
              id="checkBoxFocusingVisibility"
              :label="$t('advertisement_focusing_visibility')"
            />
          </mdb-col>
          <mdb-col md="3">
            <mdb-input
              :label="$t('advertisement_focusing_start_date')"
              type="date"
              v-model="localAdvertisement.carousel.validfrom"
            />
          </mdb-col>
          <mdb-col md="3">
            <mdb-input
              :label="$t('advertisement_focusing_end_date')"
              type="date"
              v-model="localAdvertisement.carousel.validto"
            />
          </mdb-col>
          <mdb-col md="6">
            <mdb-input
              v-model="localAdvertisement.carousel.url"
              type="text"
              icon="quote-right"
              :label="$t('advertisement_focusing_url')"
            />
          </mdb-col>
          <mdb-col md="12">
            <hr />
            <p class="h6 red-text bold">
              {{ $t("advertisement_focus_image") }}
            </p>
            <ImageInput
              :image-src="getImageSrc(true)"
              :imageWidth="400"
              :buttonName="$t('advertisement_focusing_button_name')"
              v-on:general-image="advertisementCarouselImage"
            />
            <hr />
          </mdb-col>
        </mdb-row>
        <hr class="banner" />
        <mdb-row>
          <mdb-col>
            <mdb-input
              v-model="localAdvertisement.title"
              type="text"
              icon="quote-right"
              :label="$t('advertisement_title')"
            />
          </mdb-col>
          <mdb-col>
            <mdb-input
              v-model="localAdvertisement.url"
              type="text"
              icon="globe-europe"
              :label="$t('advertisement_url')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="8">
            <mdb-input
              v-model="localAdvertisement.description"
              type="textarea"
              icon="quote-left"
              :label="$t('advertisement_description')"
            />
          </mdb-col>
          <mdb-col col="4">
            <mdb-btn
              @click="updateDescription"
              color="indigo"
              class="white-text"
              >{{ $t("advertisement_update_description") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <Categories
              v-on:categories="selectedCategories"
              :multipleSelected="true"
              :categoriesInAdv="getCategoryIds()"
            />
          </mdb-col>
          <mdb-col col="4">
            <mdb-btn
              @click="openSubCategoryPicker"
              color="indigo"
              class="white-text"
              >{{ $t("advertisement_choose_subcategories") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col class="mb-4">
            <p class="h6">
              {{ $t("advertisement_selected_subcategories") }}
            </p>
            <div class="badges">
              <span
                v-for="subCategory in subCategories"
                :key="subCategory.id"
                class="text-uppercase badge"
              >
                {{ subCategory.name }}
              </span>
            </div>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input
              v-model="localAdvertisement.mobileOnly"
              type="checkbox"
              id="checkBoxMobileOnly"
              :label="$t('advertisement_mobileonly')"
            />
          </mdb-col>
          <mdb-col>
            <mdb-input
              v-model="chainAdvertisement"
              type="checkbox"
              id="checkBoxChainAdvertisement"
              class="mt-3"
              :label="$t('advertisement_chainadvertisement')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12">
            <p class="h6">{{ $t("advertisement_from_to") }}</p>
          </mdb-col>
          <mdb-col>
            <mdb-input
              :label="$t('manage_access_code_modal_input_start')"
              type="date"
              v-model="localAdvertisement.validfrom"
            />
          </mdb-col>
          <mdb-col>
            <mdb-input
              :label="$t('manage_access_code_modal_input_end')"
              type="date"
              v-model="localAdvertisement.validto"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <hr />
            <p class="h6">{{ $t("advertisement_image") }}</p>
            <ImageInput
              :image-src="getImageSrc(false)"
              :imageWidth="400"
              :buttonName="$t('advertisement_add_image')"
              v-on:general-image="advertisementImage"
            />
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <p class="h6">{{ $t("advertisement_benefits") }}</p>
            <mdb-btn
              @click="addBenefit"
              color="indigo"
              class="white-text"
              icon="paper-plane"
              style="width: 200px"
              >{{ $t("add_benefit") }}
            </mdb-btn>
            <DataTableSimple
              v-if="benefitExists()"
              :buttonList="['Muokkaa', 'Poista']"
              v-on:pressed-button1="editBenefit"
              v-on:pressed-button2="deleteBenefit"
              :columns="columnsBenefits"
              :rows="localAdvertisement.benefits"
              :key="dataTableKey"
              width="auto"
              height="300px"
            />
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-4">
          <mdb-col>
            <p class="h6">{{ $t("advertisement_notifications") }}</p>
            <mdb-btn
              @click="addNotification"
              color="indigo"
              class="white-text"
              icon="paper-plane"
              style="width: 200px"
              >{{ $t("add_notification") }}
            </mdb-btn>
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col
            col="3"
            v-for="(item, index) in localAdvertisement.notifications"
            v-bind:index="index"
            v-bind:key="item.due"
          >
            <AdvertisementNotifications
              :item="item"
              :index="index"
              v-on:notification-removed="notificationRemoved"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12" class="mt-4">
            <mdb-btn
              @click="saveAdvertisement"
              color="indigo"
              class="white-text"
              icon="paper-plane"
              style="width: 200px"
              >{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
    <BenefitModal
      :modal-show="showBenefitModal"
      :benefit="benefit"
      :key="benefitComponentKey"
      v-on:modal-cancelled="addingBenefitCancelled"
      v-on:modal-ok="addingBenefit"
    />
    <NotificationModal
      :modal-show="showNotificationModal"
      :key="componentKey"
      v-on:modal-cancelled="addingNotificationCancelled"
      v-on:modal-ok="addingNotification"
    />
    <PickSubCategories
      :modal-show="showSubCategoryPicker"
      :key="componentKey"
      :selected-sub-cats="subCategories"
      :selected-cats="localAdvertisement.categories"
      v-on:modal-cancelled="subCategoryPickerCancelled"
      v-on:modal-ok="subCategoryPickerOk"
    />
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";
import UnionMemberSelection from "./UnionMemberSelection.vue";
import RetailerChainSelection from "./RetailerChainSelection.vue";
import GoogleMap from "./GoogleMap.vue";
import Categories from "./Categories.vue";
import ImageInput from "./ImageInput.vue";
import BenefitModal from "./BenefitModal.vue";
import AdvertisementNotifications from "./AdvertisementNotifications.vue";
import NotificationModal from "./NotificationModal.vue";
import DataTableSimple from "@/components/DataTableSimple.vue";
import PickSubCategories from "./PickSubCategories.vue";
export default {
  name: "EditAdvertisement",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    RetailerChainSelection,
    GoogleMap,
    Categories,
    ImageInput,
    BenefitModal,
    AdvertisementNotifications,
    NotificationModal,
    UnionMemberSelection,
    DataTableSimple,
    PickSubCategories,
  },
  props: {
    notificationType: String,
    defaultMarker: Object,
    copy: {
      type: Boolean,
      default: false,
    },
    ismobilepayspecific: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedMarker() {
      return this.marker;
    },
    computedBenefits: function () {
      return this.localAdvertisement.benefits;
    },
    carouselactive: {
      // getter
      get: function () {
        return this.localAdvertisement.carousel.active === 1 ? true : false;
      },
      // setter
      set: function (newValue) {
        this.localAdvertisement.carousel.active = newValue ? 1 : 0;
      },
    },
    cardview: {
      // getter
      get: function () {
        return this.localAdvertisement.carousel.cardview === 1 ? true : false;
      },
      // setter
      set: function (newValue) {
        this.localAdvertisement.carousel.cardview = newValue ? 1 : 0;
      },
    },
  },
  methods: {
    subCategoryPickerCancelled() {
      this.showSubCategoryPicker = false;
    },
    subCategoryPickerOk(selectedSubCategories) {
      this.showSubCategoryPicker = false;
      this.subCategories = selectedSubCategories;
    },
    openSubCategoryPicker() {
      this.componentKey += 1;
      this.showSubCategoryPicker = true;
    },
    deleteFormatter(params) {
      return params.data.deleted === 1 ? "POISTETAAN" : "";
    },
    setUnionMemberId(val) {
      this.localAdvertisement.unionmemberid = val;
    },
    reorderNotificationItems() {
      this.localAdvertisement.notifications.sort((a, b) =>
        a.due.localeCompare(b.due)
      );
    },
    updateDescription() {
      this.localAdvertisement.description = this.chainDescription;
    },
    selectedRadius(val) {
      this.localAdvertisement.notificationradius = val;
      console.log(val);
    },
    notificationRemoved(val) {
      this.localAdvertisement.notifications =
        this.localAdvertisement.notifications.filter((item) => item !== val);
      this.reorderNotificationItems();
    },
    getnotificationItems(nots, members) {
      this.localAdvertisement.notifications = [];
      try {
        nots.split(",").forEach((element, index) => {
          var notificationItem = new Object();
          if (element.length > 0) {
            notificationItem.due = element;
            notificationItem.unionmemberid = members.split(",")[index];
            this.localAdvertisement.notifications.push(notificationItem);
          }
        });
      } catch (err) {
        console.log("No Nots");
      }
      this.reorderNotificationItems();
      return this.localAdvertisement.notifications;
    },
    getCategoryIds() {
      return this.localAdvertisement.categories;
    },
    advertisementImage(val) {
      this.localAdvertisement.image = val;
    },
    advertisementCarouselImage(val) {
      this.localAdvertisement.carousel.image = val;
    },
    benefitExists() {
      return this.localAdvertisement.benefits.length > 0 ? true : false;
    },
    notificationExists() {
      return false;
    },
    addNotification() {
      this.componentKey += 1;
      this.showNotificationModal = true;
    },
    addingNotificationCancelled() {
      this.showNotificationModal = false;
    },
    addingNotification(val) {
      if (val.due !== "") {
        var notificationItem = new Object();
        notificationItem.due = val.due + ":00";
        notificationItem.radius = val.radius;
        notificationItem.unionmemberid =
          val.unionmemberid == "" ? null : val.unionmemberid;
        notificationItem.title = val.title;
        notificationItem.lat = this.marker.position.lat;
        notificationItem.lng = this.marker.position.lng;
        notificationItem.groups = val.groups;
        this.localAdvertisement.notifications.push(notificationItem);
        this.reorderNotificationItems();
        this.showNotificationModal = false;
      }
    },
    deleteBenefit(val) {
      this.localAdvertisement.benefits.find(
        (benefit) => benefit.id === val.id
      ).deleted = 1;
      this.dataTableKey += 1;
    },
    editBenefit(val) {
      this.benefit = val;
      this.benefitComponentKey += 1;
      this.showBenefitModal = true;
    },
    addBenefit() {
      this.benefit = this.initializeBenefit();
      this.benefitComponentKey += 1;
      this.showBenefitModal = true;
    },
    addingBenefitCancelled() {
      this.showBenefitModal = false;
    },
    addingBenefit(val) {
      if (val.id > 0) {
        this.localAdvertisement.benefits[
          this.localAdvertisement.benefits.findIndex((el) => el.id === val.id)
        ] = val;
      } else {
        this.localAdvertisement.benefits.push(val);
      }
      this.showBenefitModal = false;
      this.dataTableKey += 1;
    },
    initializeBenefit() {
      return {
        benefitid: 0,
        text: "",
        title: "",
        type: "ONCE",
        buttontext: "",
        deleted: 0,
        validfrom: "",
        id: 0,
        order: 0,
        restrictions: "",
        validto: "0",
        url: "",
        code: 0,
        codegeneric: "",
        barcode: "",
        qrcode: "",
      };
    },
    initializeCategory() {
      return {
        id: 0,
        name: "",
        display: "",
      };
    },
    initializeRetailer() {
      return {
        id: 0,
        name: "",
        lat: 0,
        lng: 0,
      };
    },
    initializeRetailerChain() {
      return {
        id: 0,
        name: "",
        description: "",
      };
    },
    loadAdvertisement() {
      if (!this.isNewAdvertisement()) {
        this.getAdvertisement(this.getAdvertisementId());
      } else {
        this.loadReady = true;
      }
    },
    getAppOnly() {
      return this.localAdvertisement.mobileOnly === true ? 1 : 0;
    },
    setMobileOnly() {
      this.localAdvertisement.mobileonly === 1
        ? (this.localAdvertisement.mobileOnly = true)
        : (this.localAdvertisement.mobileOnly = false);
    },
    setChainAdvertisement() {
      this.localAdvertisement.chainadvertisement !== 0
        ? (this.chainAdvertisement = true)
        : (this.chainAdvertisement = false);
    },
    getChainAdvertisement() {
      return this.chainAdvertisement === true ? 1 : 0;
    },
    getRetailerId() {
      return this.localAdvertisement.retailer_id;
    },
    getAdvertisementIdForUI() {
      if (this.copy === true) return "0";
      else return this.getAdvertisementId();
    },
    getAdvertisementId() {
      try {
        return parseInt(this.$route.path.match(/(\d+)/)[0]);
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    isNewAdvertisement() {
      return this.getAdvertisementId() === 0;
    },
    dateTimeChanged(val) {
      if (this.dateTime.localeCompare(val) !== 0) {
        this.dateTime = val;
      }
    },
    createMarker() {
      var marker = {
        name: "Position",
        position: {
          lat: Number(this.marker.position.lat),
          lng: Number(this.marker.position.lng),
        },
        radius: this.marker.radius,
      };
      this.marker = marker;
    },
    markerMoved(val) {
      this.marker.position.lat = val.getPosition().lat();
      this.marker.position.lng = val.getPosition().lng();
      this.createMarker();
      console.log(val);
    },
    selectedCategories(value, text) {
      this.categories = value.toString();
      console.log(value, text);
    },
    member(member, retailerChainId, description) {
      console.log(retailerChainId);
      console.log(description);
      this.localAdvertisement.retailer_id = member.id;
      this.marker.position.lat = member.lat;
      this.marker.position.lng = member.lng;
      this.createMarker();
    },
    getImageSrc(focus) {
      if (focus) {
        if (this.localAdvertisement.carousel.image === "")
          return "https://mdbootstrap.com/img/Photos/Others/placeholder.jpg";
        else return this.localAdvertisement.carousel.image;
      } else {
        if (this.localAdvertisement.image === "")
          return "https://mdbootstrap.com/img/Photos/Others/placeholder.jpg";
        else return this.localAdvertisement.image;
      }
    },
    setCategories(categories) {
      this.localAdvertisement.categories = categories;
      var _this = this;
      this.localAdvertisement.categories.forEach((element) => {
        _this.categories.push(element.id);
      });
    },
    setSubCategories(subCategories) {
      this.subCategories = subCategories;
      this.localAdvertisement.subCategories = subCategories;
    },
    setBenefits(benefits) {
      this.localAdvertisement.benefits = benefits;
    },
    setNotifications(notifications) {
      this.localAdvertisement.notifications = notifications;
    },
    setCarousel(carousel) {
      this.localAdvertisement.carousel = carousel;
    },
    fillLocalAdvertisement(val) {
      this.localAdvertisement.id = val.id;
      this.localAdvertisement.retailer_id = val.retailer.id;
      this.localAdvertisement.retailerchain = val.retailerchain;
      this.localAdvertisement.partner_id = val.partner_id;
      this.localAdvertisement.title = val.title;
      this.localAdvertisement.description = val.description;
      this.localAdvertisement.validfrom = val.validfrom;
      this.localAdvertisement.validto = val.validto;
      this.localAdvertisement.image = val.image;
      this.localAdvertisement.url = val.url;
      this.localAdvertisement.unionmemberid = val.unionmemberid;
      this.localAdvertisement.mobileonly = val.mobileonly;
      this.localAdvertisement.mobilepayspecific = val.mobilepayspecific;
      this.localAdvertisement.chainadvertisement = val.chainadvertisement;
      this.setMobileOnly();
      this.setCarousel(val.carousel);
      this.setCategories(val.categories);
      this.setSubCategories(val.subcategories);
      this.setBenefits(val.benefits);
      this.setNotifications(val.notifications);
      this.setChainAdvertisement();
      this.marker.position.lat = val.lat;
      this.marker.position.lng = val.lng;
      this.createMarker();
      console.log(val);
    },
    getAdvertisement(id) {
      this.$notify.info({
        message: this.$t("loading_advertisement"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.getadvertisementpath + id)
        .then((response) => {
          if (response.status == 200) {
            this.fillLocalAdvertisement(response.data.advertisements[0]);
            this.loadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    checkBenefitsOrderDuplicates() {
      const uniqueValues = new Set(
        this.localAdvertisement.benefits.map((benefit) => benefit.order)
      );
      return uniqueValues.size < this.localAdvertisement.benefits.length;
    },
    saveAdvertisement() {
      if (this.checkBenefitsOrderDuplicates()) {
        this.$notify.error({
          message: this.$t("benefit_duplicate_orderids"),
          position: "top right",
          timeOut: this.$store.state.notifytimeoutmedium,
        });
        return;
      }
      try {
        if (this.ismobilepayspecific)
          this.localAdvertisement.mobilepayspecific = 1;
        else this.localAdvertisement.mobilepayspecific = 0;
        this.postData = {
          sessionid: this.$store.getters.getToken,
          id: this.copy ? null:this.getAdvertisementId(),
          image: this.localAdvertisement.image,
          description: this.localAdvertisement.description,
          title: this.localAdvertisement.title,
          lat: this.marker.position.lat,
          lng: this.marker.position.lng,
          validfrom: this.localAdvertisement.validfrom,
          validto: this.localAdvertisement.validto,
          apponly: this.getAppOnly(),
          url: this.localAdvertisement.url,
          retailer_id: this.getRetailerId(),
          unionmember_id: this.localAdvertisement.unionmemberid,
          benefits: this.localAdvertisement.benefits,
          categories:
            typeof this.categories === "string"
              ? this.categories
              : this.categories.toString(),
          subcategories: this.subCategories.map((sub) => sub.id).join(","),
          notifications: this.localAdvertisement.notifications,
          carousel: this.localAdvertisement.carousel,
          type: "ADVERTISEMENT",
          mobilepayspecific: this.localAdvertisement.mobilepayspecific,
          chainadvertisement: this.getChainAdvertisement(),
        };
        this.$http
          .post(this.addadvertisementpath, JSON.stringify(this.postData))
          .then((response) => {
            if (response.status == 200) {
              this.$notify.success({
                message: this.$t("adding_advertisement_success"),
                position: "top right",
                timeOut: this.$store.state.notifytimeoutshort,
              });
            }
            this.$emit("modal-ok");
            this.ismobilepayspecific
              ? this.$router.push("/mobilepayadvertisements")
              : this.$router.push("/advertisements");
          })
          .catch((error) => {
            this.$notify.error({
              message: this.$t("adding_advertisement_not_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
            this.$emit("modal-ok");
            console.log(error);
          })
          .finally(() => (this.loading = false));
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.loadAdvertisement();
  },
  data() {
    return {
      addadvertisementpath: "/1.0/front/advertisement",
      getadvertisementpath: "/1.0/front/advertisement/",
      dataTableKey: 0,
      notificationData: null,
      title: "",
      description: "",
      dateTime: "",
      formattedDateTime: "",
      categories: [],
      chainAdvertisement: false,
      marker: this.defaultMarker,
      loadReady: false,
      startDate: "",
      endDate: "",
      showBenefitModal: false,
      showNotificationModal: false,
      showSubCategoryPicker: false,
      componentKey: 0,
      benefitComponentKey: 0,
      benefit: this.initializeBenefit(),
      chainDescription: "",
      advertisementid: undefined,
      localAdvertisement: {
        id: 0,
        retailer_id: 0,
        partner_id: 0,
        type: "",
        title: "",
        description: "",
        retailerChainId: 0,
        validfrom: "",
        validto: "",
        image: "",
        carousel: {
          active: 0,
          cardview: 0,
          url: "",
          image: "",
          validfrom: null,
          validto: null,
        },
        categories: [],
        subCategories: [],
        benefits: [],
        notifications: [],
        url: "",
        unionmemberid: null,
      },
      sliderData: [
        1, 2, 3, 5, 7, 10, 15, 20, 30, 40, 50, 70, 100, 200, 300, 500, 700,
        1000, 1500,
      ],
      columnsBenefits: [
        {
          headerName: "Poistetaan talletettaessa",
          field: "deleted",
          width: 100,
          cellStyle: { color: "red", "font-size": "1.2em" },
          valueFormatter: this.deleteFormatter,
          // pinned: "left",
        },
        {
          headerName: "Otsikko",
          field: "title",
          width: 150,
          // pinned: "left",
        },
        {
          headerName: "Kuvaus",
          field: "text",
          width: 150,
          // pinned: "left",
        },
        {
          headerName: "Edun järjestysnumero",
          field: "order",
          width: 50,
          // pinned: "left",
        },
        {
          headerName: "Edun tyyppi",
          field: "type",
          width: 50,
          // pinned: "left",
        },
        {
          headerName: "Alkaa",
          field: "validfrom",
          width: 100,
          // pinned: "left",
        },
        {
          headerName: "Päättyy",
          field: "validto",
          width: 100,
          // pinned: "left",
        },
        {
          headerName: "url-osoite",
          field: "url",
          // pinned: "left",
        },
        {
          headerName: "Rajoitukset",
          field: "restrictions",
          width: 100,
          // pinned: "left",
        },
        {
          headerName: "Yleinen koodi",
          field: "codegeneric",
          width: 100,
          // pinned: "left",
        },
        {
          headerName: "Uniikki koodi",
          field: "code",
          width: 100,
          // pinned: "left",
        },
        {
          headerName: "Viivakoodi",
          field: "barcode",
          width: 100,
        },
        {
          headerName: "QR-koodi",
          field: "qrcode",
          width: 100,
        },
      ],
    };
  },
};
</script>

<style scoped>
hr.banner {
  border-top: 10px solid grey;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.badge {
  padding: 8px 12px;
  border-radius: 20px;
  background-color: #d5007e;
  cursor: pointer;
  transition: 0.3s;
  border: 2px solid transparent;
}
</style>
